import { createContext } from 'react';

// Permissions
export const PermissionContext = createContext(true);
